import type { ReactNode } from 'react';
import AppShell from './AppShell';
import LegalFooter from './LegalFooter';

/**
 * 認證畫面外殼（**登入／登記／職員登入共用**；產品負責人 2026-10-06）
 *
 * 為何抽出：呢個版面（卡片置中 ＋ 法務連結貼底）已經改過幾次；
 *   散落 4 處一定漂移 → 集中一個檔，以後調整只改呢度。
 *
 *  · **卡片垂直置中，但整張卡上移 50px**（`AUTH_CARD_LIFT_PX`；20px → 再加 30px）
 *  · 法務連結**貼螢幕最底、卡片外面**（`LegalFooter`；帶 `safe-area-inset-bottom`）
 *  · ⚠️ 唔用 `transform: translateY` —— 用**底部多留 2× 上移量**令置中點上移，
 *    唔會影響捲動範圍／字型渲染（半像素模糊）。
 */
export const AUTH_CARD_LIFT_PX = 50;

export default function AuthScreen({
  children,
  absoluteLinks = false,
  title,
}: {
  children: ReactNode;
  /** 理事會端（第 2 個 PWA）要用真 `<a>`（router 只有 `/committee/*`） */
  absoluteLinks?: boolean;
  title?: string;
}) {
  return (
    <AppShell title={title}>
      <div className="flex flex-col" style={{ minHeight: 'calc(100vh - var(--topbar-h))' }}>
        <div
          className="flex-1 flex items-center justify-center p-6"
          style={{ paddingBottom: `calc(1.5rem + ${AUTH_CARD_LIFT_PX * 2}px)` }}
        >
          {children}
        </div>
        <LegalFooter absoluteLinks={absoluteLinks} />
      </div>
    </AppShell>
  );
}
